import React, { useEffect, useState } from "react";
import Popup from "../../../hoc/Popup/Popup";
import { ICourt, ISlotHistory, ISummaryItem } from "../../../types/api";
import {
  createSlotWarning,
  getSlotHistory,
} from "../../../api/slotHistory/slotHistory";
import { formatDate, formatToIsoDate } from "../../../shared/dateUtils";
import { formatDateToSwedish } from "../../../shared/utility";
import "./CreateSlotWarningPopup.scss";
import { toast } from "react-toastify";
import HandleConfirmationPopup from "../../HandleConfirmation/HandleConfirmationPopup";
import cross from "../../../assets/images/cross.svg";
interface ICreateSlotWarningPopupProps {
  showPopup: boolean;
  onClose: () => void;
  onConfirm: () => void;
  start_time?: string;
  court_id: string;
  filterDate: Date;
  selectedSlotsProp: {
    warning: string;
    court_id: string;
    start_time: string;
    end_time: string;
  }[];
  courts: ICourt[];
}

function CreateSlotWarningPopup({
  showPopup,
  onConfirm,
  onClose,
  selectedSlotsProp,
  start_time,
  court_id,
  courts,
  filterDate,
}: ICreateSlotWarningPopupProps) {
  const [showCreateWarningPopup, setShowCreateWarningPopup] = useState(false);
  const [slots, setSlots] = useState(selectedSlotsProp);

  useEffect(() => {
    setSlots(selectedSlotsProp);
  }, [selectedSlotsProp]);
  const [warning, setWarning] = useState("");
  const [loading, setLoading] = useState(false);
  const popupDateString = formatDate(filterDate, "yyyy-MM-dd");
  const courtNames = courts.map((court) => court.name);
  const handleClose = () => {
    setShowCreateWarningPopup(false);
    setWarning("");
    onClose();
  };

  const handleConfirm = () => {
    onConfirm();
    handleClose();
  };
  const delay = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms));

  const handleCreateWarning = async () => {
    const date = formatToIsoDate(filterDate).split("T")[0];

    try {
      const loadToast = toast.loading("Skapar varningar...");
      setLoading(true);
      for (let i = 0; i < slots.length; i++) {
        await createSlotWarning(
          date + "T" + slots[i].start_time,
          slots[i].court_id,
          warning,
        );
        await delay(200); // Wait 200ms between each request
      }
      setLoading(false);
      toast.dismiss(loadToast);
      toast.success("Varning skapad");
      handleConfirm();
    } catch (error) {
      toast.error("Kunde inte skapa varning");
    }
  };
  const removeSlot = (slotToRemove: {
    court_id: string;
    start_time: string;
  }) => {
    setSlots((prev) =>
      prev.filter(
        (s) =>
          !(
            s.court_id === slotToRemove.court_id &&
            s.start_time === slotToRemove.start_time
          ),
      ),
    );
  };

  const sortedSlots = [...slots].sort((a, b) => {
    const courtA = courts.find((court) => court.court_id === a.court_id);
    const courtB = courts.find((court) => court.court_id === b.court_id);

    if (courtA && courtB) {
      const courtComparison = courtA.name.localeCompare(courtB.name);

      if (courtComparison === 0) {
        return a.start_time.localeCompare(b.start_time);
      }

      return courtComparison;
    }

    return a.start_time.localeCompare(b.start_time);
  });

  return (
    <Popup
      showPopup={showPopup}
      onClose={handleClose}
      leftTopElement={
        <span className="text-m">
          Skapa varning den {popupDateString} för följande tider och banor:
        </span>
      }
    >
      <div className="general-popup-wrapper">
        <form
          className="general-popup-form"
          onSubmit={(e) => {
            e.preventDefault();
            setShowCreateWarningPopup(true);
          }}
        >
          {sortedSlots.map((slot, index) => {
            const courtName = courts.find(
              (court) => court.court_id === slot.court_id,
            );
            return (
              <div key={index} className="slot-warning-item">
                <div className="text-m">
                  Bana: {courtName?.name}, Tid: {slot.start_time.slice(0, 5)} -{" "}
                  {slot.end_time.slice(0, 5)}, Varning: {slot.warning}{" "}
                  {(!slot.warning || slot.warning === "") && "Ingen varning "}
                </div>
                <img
                  className="pointer"
                  src={cross}
                  alt="cross"
                  onClick={() => removeSlot(slot)}
                />
              </div>
            );
          })}
          <div className="general-popup-form-group">
            <div className="general-popup-form-field">
              <label htmlFor="comment" className="text-s">
                Varningsmedelande
              </label>
              <input
                type="text"
                name="comment"
                id="comment"
                className="text-m"
                value={warning}
                onChange={(e) => setWarning(e.target.value)}
              />
            </div>
          </div>
          <div className="general-popup-bottom-buttons-wrapper flex-end">
            <button type="submit" className="text-m">
              Lägg till varning
            </button>
          </div>
        </form>
      </div>
      <HandleConfirmationPopup
        showPopup={showCreateWarningPopup}
        onClose={() => setShowCreateWarningPopup(false)}
        onConfirm={handleCreateWarning}
        confirmText="Skapa varning"
        denyText="Avbryt"
        questionText="Är du säker på att du vill skapa denna varning?"
        loading={loading}
      />
    </Popup>
  );
}

export default CreateSlotWarningPopup;
